export default __webpack_public_path__ + "static/media/oscer-pres-wheeze.7d01b0cd.svg";